export default __webpack_public_path__ + "static/media/blue1.82648a53.png";